var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_container"},[_c('comp_filters'),_c('comp_modal_overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }